import { useQueryClient } from "@tanstack/react-query";
import { ImageStudioHost } from "@/components/images/ImageStudioHost";
import {
  closeImageStudio,
  useImageStudioState,
} from "./image-studio-store";

/**
 * PuckImageStudioHost — monte UNE seule fois l'éditeur de retouche (`ImageStudio`)
 * hors du panneau de champs Puck (via `overrides.puck` dans editor.tsx), à l'abri
 * des démontages du champ. Les champs image ouvrent l'éditeur via le store
 * (`openImageStudio(attachment)`).
 *
 * La retouche régénère les dérivés S3 sur place (même `link`/id) : on n'écrit
 * rien sur le bloc Puck. Après enregistrement, on invalide les queries
 * d'attachment pour que les aperçus rechargent la nouvelle image.
 */
export function PuckImageStudioHost() {
  const { open, attachment } = useImageStudioState();
  const queryClient = useQueryClient();

  return (
    <ImageStudioHost
      attachment={attachment}
      open={open}
      onOpenChange={(next) => {
        if (!next) closeImageStudio();
      }}
      onSaved={() => {
        void queryClient.invalidateQueries({ queryKey: ["attachment"] });
        void queryClient.invalidateQueries({
          queryKey: ["artworks", "attachments"],
        });
      }}
    />
  );
}
